/**
 * Canonical EMS skill options for profile selection and endorsements.
 * Single source of truth; backward compatible with existing profile skills (Record<string, boolean>).
 */
export const EMS_SKILL_OPTIONS = [
  "Patient Assessment",
  "Airway Management",
  "Trauma Care",
  "Cardiac Care",
  "Pediatric Care",
  "Documentation",
  "Radio Communication",
  "Scene Management",
  "De-escalation",
  "Lifting and Moving",
  "Team Leadership",
  "IFT Operations",
  "911 Response",
  "Rural EMS",
  "Bilingual Communication",
] as const;

export type EMSSkillName = (typeof EMS_SKILL_OPTIONS)[number];

/** Slug for stable doc ids (alphanumeric + underscore, max 50 chars). */
export function skillNameToSlug(skillName: string): string {
  return skillName
    .replace(/\s+/g, "_")
    .replace(/[^a-zA-Z0-9_-]/g, "")
    .slice(0, 50) || "skill";
}

/**
 * All skill keys to show in the selector: canonical list + legacy keys from profile so we don't lose data.
 */
export function getAllSkillOptionsForProfile(existingSkillKeys: string[]): string[] {
  const fromProfile = existingSkillKeys.filter((k) => k && !EMS_SKILL_OPTIONS.includes(k as any));
  const combined = [...EMS_SKILL_OPTIONS, ...fromProfile];
  return [...new Set(combined)];
}
